/* Fragment navigation belongs to the legal document, not the global RTE handler. */
(() => {
  const initialized = new WeakSet();

  function findTarget(content, hash) {
    if (!hash || hash === '#') return null;

    let name;
    try {
      name = decodeURIComponent(hash.slice(1));
    } catch {
      return null;
    }

    const anchor = document.getElementById(name)
      || Array.from(document.getElementsByName(name)).find(element => content.contains(element));
    if (!anchor || !content.contains(anchor)) return null;

    return anchor.closest('h1, h2, h3, h4, h5, h6') || anchor;
  }

  function reveal(content, hash, behavior) {
    const target = findTarget(content, hash);
    if (!target || !target.isConnected) return false;

    const header = document.querySelector('.Header');
    const headerBottom = Math.max(0, header ? header.getBoundingClientRect().bottom : 0);
    const gap = parseFloat(getComputedStyle(content).fontSize);
    const top = target.getBoundingClientRect().top + window.scrollY - headerBottom - gap;

    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
    window.scrollTo({ top: Math.max(0, top), behavior });
    return true;
  }

  function initialize(root) {
    if (initialized.has(root)) return;
    const content = root.querySelector('.LegalDocument__Content');
    if (!content) return;
    initialized.add(root);

    content.addEventListener('click', event => {
      if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey
        || event.shiftKey || event.altKey) return;

      const link = event.target.closest('a[href^="#"]');
      if (!link || !content.contains(link) || link.hasAttribute('download')
        || (link.target && link.target !== '_self')) return;

      const hash = link.getAttribute('href');
      if (!findTarget(content, hash)) return;

      event.preventDefault();
      // The theme's body listener only supports IDs and uses an incorrect offset.
      event.stopPropagation();
      if (window.location.hash !== hash) {
        const url = new URL(window.location.href);
        url.hash = hash;
        window.history.pushState(window.history.state, '', url);
      }
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      reveal(content, hash, reducedMotion ? 'instant' : 'smooth');
    });

    const restoreFragment = () => {
      if (!window.location.hash) return;
      requestAnimationFrame(() => reveal(content, window.location.hash, 'instant'));
    };
    window.addEventListener('hashchange', restoreFragment);
    if (window.location.hash) {
      document.fonts.ready.then(restoreFragment);
      window.addEventListener('load', restoreFragment, { once: true });
    }
  }

  function initializeDocuments(scope) {
    scope.querySelectorAll('[data-legal-document]').forEach(initialize);
  }

  initializeDocuments(document);
  document.addEventListener('shopify:section:load', event => initializeDocuments(event.target));
})();
